"use strict";

var _slicedToArray = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/styles");
var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));
var _theme = require("../config/theme.config");
var _WobiStylesProvider = _interopRequireDefault(require("./WobiStylesProvider"));
var _AccessibilityMenu = _interopRequireDefault(require("./AccessibilityMenu"));
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var WobiThemeProvider = function WobiThemeProvider(props) {
  var _react$default$useSta = _react.default.useState(false),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    isHighContrast = _react$default$useSta2[0],
    setHighContrast = _react$default$useSta2[1];
  var _react$default$useSta3 = _react.default.useState(false),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    isFontBigger = _react$default$useSta4[0],
    setFontBigger = _react$default$useSta4[1];
  var newTheme = (0, _theme.theme)({
    isFontBigger: isFontBigger,
    isHighContrast: isHighContrast
  });
  return /*#__PURE__*/_react.default.createElement(_WobiStylesProvider.default, null, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, _extends({}, props, {
    theme: newTheme
  }), /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), /*#__PURE__*/_react.default.createElement(_AccessibilityMenu.default, {
    handleContrast: function handleContrast() {
      return setHighContrast(!isHighContrast);
    },
    handleFontBigger: function handleFontBigger() {
      return setFontBigger(!isFontBigger);
    },
    handleReset: function handleReset() {
      setFontBigger(false);
      setHighContrast(false);
    }
  }), props.children));
};
WobiThemeProvider.propTypes = {
  children: _propTypes.default.any
};
var _default = exports.default = WobiThemeProvider;